module.exports = __webpack_public_path__ + "img/shine.48a20dd6.svg";